import { storage, db } from "../firebase/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { convertToJpg } from "../utils/images";
import { doc, updateDoc } from "firebase/firestore";

export const uploadFotoJpg = async (id, index, file) => {
  const jpgFile = await convertToJpg(file);
  const objectName = `motos/${id}/${id}_F${index}.jpg`;
  const r = ref(storage, objectName);
  await uploadBytes(r, jpgFile);
  const url = await getDownloadURL(r);
  const field = `foto${index}`;
  await updateDoc(doc(db, "motos", id), { [field]: url });
  return { field, url };
};

export const clearFoto = async (id, index) => {
  const field = `foto${index}`;
  await updateDoc(doc(db, "motos", id), { [field]: null });
  return field;
};

export const uploadVideoAny = async (id, file) => {
  const ext = (file.name.split(".").pop() || "mp4").toLowerCase();
  const objectName = `motos/${id}/${id}_V1.${ext}`;
  const r = ref(storage, objectName);
  await uploadBytes(r, file);
  const url = await getDownloadURL(r);
  await updateDoc(doc(db, "motos", id), { video: url });
  return url;
};

export const clearVideo = async (id) => {
  await updateDoc(doc(db, "motos", id), { video: null });
  return true;
};

/**
 * Sube un JPG a un área temporal exclusiva por usuario.
 * NO toca Firestore.
 * @param {string} uid - uid del usuario autenticado
 * @param {number} index - 1..7
 * @param {File} file - imagen
 * @returns {Promise<{url: string, path: string}>}
 */
export async function uploadFotoJpgTemp(uid, index, file) {
  if (!uid) throw new Error("Falta uid para ruta temporal");
  const safeIndex = Math.max(1, Math.min(7, Number(index) || 1));
  const path = `drafts/${uid}/f${safeIndex}.jpg`;
  const r = ref(storage, path);
  await uploadBytes(r, file);
  const url = await getDownloadURL(r);
  return { url, path };
};

/**
 * Sube un VIDEO temporal para el usuario.
 * NO toca Firestore.
 */
export async function uploadVideoTemp(uid, file) {
  if (!uid) throw new Error("Falta uid para ruta temporal");
  const path = `drafts/${uid}/video`;
  const r = ref(storage, path);
  await uploadBytes(r, file);
  const url = await getDownloadURL(r);
  return { url, path };
};

/**
 * (Opcional) Subida definitiva por código de moto una vez creada.
 * Úsalo si luego quieres mover del draft a la carpeta final.
 */
export async function uploadFotoFinal(codigoMoto, index, file) {
  const safeIndex = Math.max(1, Math.min(7, Number(index) || 1));
  const path = `motos/${codigoMoto}/${codigoMoto}_F${safeIndex}.jpg`;
  const r = ref(storage, path);
  await uploadBytes(r, file);
  const url = await getDownloadURL(r);
  return { url, path };
};